import {LayoutEntryGutterCommentsState, LayoutEntryGutterMetricsState} from '../_reducers/layout';
import * as types from './types';

/**
 * NOTE - the return type of the methods in this file is explicitly set to any instead of LayoutAction as I
 * couldn't get all the type errors resolved
 * The reducer handles partial objects being passed so this is safe
 */

export function setLayoutEntryGutterComments(layout: LayoutEntryGutterCommentsState): any {
    return {
        type: types.LAYOUT_ENTRY_GUTTER_COMMENTS_SET,
        layout: {
            entryGutter: {
                comments: layout
            }
        }
    }
}

export function setLayoutEntryGutterMetrics(layout: LayoutEntryGutterMetricsState): any {
    return {
        type: types.LAYOUT_ENTRY_GUTTER_METRICS_SET,
        layout: {
            entryGutter: {
                metrics: layout
            }
        }
    }
}